import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useMenuStore } from '@/stores/menu.js';

/**
 * 從資料庫讀取程序名稱的 composable
 * @param {string} defaultTitle - 預設標題（當找不到匹配的程序時使用）
 * @returns {ComputedRef<string>} 頁面標題
 */
export function usePageTitle(defaultTitle = '') {
  const route = useRoute();
  const menuStore = useMenuStore();

  const pageTitle = computed(() => {
    const currentPath = route.path;
    const formattedMenu = menuStore.formattedMenu;
    
    // 如果選單資料還沒載入，使用預設標題
    if (!formattedMenu || formattedMenu.length === 0) {
      return defaultTitle;
    }
    
    // 先嘗試完全匹配
    for (const module of formattedMenu) {
      for (const program of module.children || []) {
        if (program.path === currentPath) {
          return program.name;
        }
      }
    }

    // 如果完全匹配失敗，嘗試路徑前綴匹配（處理子路由）
    let bestMatch = null;
    let bestMatchLength = 0;
    
    for (const module of formattedMenu) {
      for (const program of module.children || []) {
        if (program.path && currentPath.startsWith(program.path)) {
          const pathEnd = currentPath[program.path.length];
          if (!pathEnd || pathEnd === '/' || pathEnd === '?') {
            if (program.path.length > bestMatchLength) {
              bestMatch = program.name;
              bestMatchLength = program.path.length;
            }
          }
        }
      }
    }

    if (bestMatch) {
      return bestMatch;
    }

    // 如果找不到，使用預設標題
    return defaultTitle;
  });

  return { pageTitle };
}













